import { withBemMod } from '@bem-react/core';
import React, { createRef } from 'react';
import ReactSwipe from 'react-swipe';
import { Omit } from 'utility-types';

import HtmlContent from 'client/common/components/html-content';
import { ILevelMedia } from 'client/common/types';
import i18n from 'utils/i18n';

import { cnLevel, ILevelProps } from '..';

import './level_type_carousel.css';

export interface ILevelTypeCarouselProps extends Omit<ILevelMedia, 'type'> {
    type?: 'carousel';
}

export const withLevelTypeCarousel = withBemMod<ILevelTypeCarouselProps, ILevelProps>(
    cnLevel(),
    { type: 'carousel' },
    (BaseLevel: React.FC<ILevelProps>) => props => {
        const { title, subtitle, blocks, description, ...otherProps } = props;

        const swipeRef = createRef<ReactSwipe>();

        const prev = () => swipeRef.current && swipeRef.current.prev();
        const next = () => swipeRef.current && swipeRef.current.next();

        return (
            <BaseLevel {...otherProps}>
                <>
                    {title && (
                        <h2
                            className={cnLevel('title')}
                            dangerouslySetInnerHTML={{ __html: title }}
                            />
                    )}
                    {subtitle && (
                        <h3
                            className={cnLevel('subtitle')}
                            dangerouslySetInnerHTML={{ __html: subtitle }}
                            />
                    )}
                    {description && (
                        <HtmlContent className={cnLevel('description')} content={description} />
                    )}
                    <ReactSwipe
                        className={cnLevel('swipe')}
                        ref={swipeRef}
                        >
                        {blocks && blocks.map(({ image, bottomText }, id) =>
                            (
                                <div
                                    key={image}
                                    className={cnLevel('block')}
                                    >
                                    {image && (
                                        <img
                                            className={cnLevel('image')}
                                            src={image}
                                            alt=""
                                            />
                                    )}
                                    <div className={cnLevel('caption')}>
                                        {bottomText && (
                                            <HtmlContent
                                                className={cnLevel('bottom-text')}
                                                content={bottomText}
                                                />
                                        )}
                                        <div
                                            className={cnLevel('slide-info')}
                                            >
                                            {`${id + 1} ${i18n({
                                                key: 'swipe.slideInfo',
                                                keyset: 'common'
                                            })} ${blocks.length}`}
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </ReactSwipe>
                    <div className={cnLevel('buttons')}>
                        <div className={cnLevel('button-prev')} onClick={prev} />
                        <div className={cnLevel('button-next')} onClick={next} />
                    </div>
                </>
            </BaseLevel>
        );
    }
);
